"use client";

import Image, { StaticImageData } from "next/image";

import { SpotifyEmbed } from "@/components/SpotifyEmbed";
import { Heading4 } from "@/components/text/Heading4";
import { getSizesString } from "@/utils/getSizesString";

export function TrackUseCase({
  title,
  image,
  spotifyTrackId,
}: {
  title: string;
  image: StaticImageData;
  spotifyTrackId: string;
}) {
  return (
    <div className="flex w-full flex-col items-center gap-2 rounded-3xl bg-primaryLight px-4 py-2">
      <Heading4 elementType="h3" className="text-center">
        {title}
      </Heading4>
      <div className="flex w-full flex-row items-center justify-center gap-4">
        <div className="hidden w-full max-w-[100px] overflow-hidden rounded-3xl lg:block">
          <div className="aspect-h-1 aspect-w-1 relative rounded-3xl">
            <Image
              src={image}
              alt={title}
              className="object-cover"
              fill={true}
              sizes={getSizesString({
                sm: 100,
                md: 50,
                lg: 33,
                rest: 25,
              })}
            />
          </div>
        </div>

        <div className="flex w-full flex-1 flex-col items-center justify-center gap-y-2">
          <SpotifyEmbed spotifyTrackId={spotifyTrackId} />
        </div>
      </div>
    </div>
  );
}
